import { IconButton, type IconButtonProps, Tooltip, alpha } from '@mui/material';
import { type ReactNode } from 'react';

interface AgenticChatToolbarButtonProps extends Omit<
  IconButtonProps,
  'aria-label' | 'children' | 'color' | 'size'
> {
  label: string;
  icon: ReactNode;
}

export function AgenticChatToolbarButton(props: AgenticChatToolbarButtonProps) {
  const { label, icon, sx = [], ...iconButtonProps } = props;

  return (
    <Tooltip title={label} arrow placement="bottom">
      <IconButton
        {...iconButtonProps}
        size="small"
        color="inherit"
        aria-label={label}
        sx={[
          (theme) => ({
            borderRadius: 1,
            opacity: 0.82,
            '&:hover, &.Mui-focusVisible': {
              opacity: 1,
              backgroundColor: alpha(theme.palette.common.white, 0.16),
            },
            '&[aria-expanded="true"]': {
              opacity: 1,
              backgroundColor: alpha(theme.palette.common.white, 0.22),
              '&:hover': { backgroundColor: alpha(theme.palette.common.white, 0.28) },
            },
          }),
          ...(Array.isArray(sx) ? sx : [sx]),
        ]}
      >
        {icon}
      </IconButton>
    </Tooltip>
  );
}
